import { AppService } from './app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
var LogoutComponent = /** @class */ (function () {
    function LogoutComponent(_service, _router, router, spinnerService) {
        this._service = _service;
        this._router = _router;
        this.router = router;
        this.spinnerService = spinnerService;
        this.typeSelected = 'ball-fussion';
    }
    LogoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log("LogoutComponent initialized");
        this.showSpinner();
        setTimeout(function () {
            _this._service.logout();
            _this.spinnerService.hide();
        }, 3000); // 1 second
    };
    LogoutComponent.prototype.showSpinner = function () {
        this.spinnerService.show();
    };
    return LogoutComponent;
}());
export { LogoutComponent };
